import { NgModule } from '@angular/core';
import { DataEngagementApiModule } from '@epicuro-next/data/engagement/engagement-api';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { RouterStoreModule } from '@epicuro-next/state/router-store';
import { SessionStateModule } from '@epicuro-next/state/session-state';
import { StateSitesStateModule } from '@epicuro-next/state/site-state';
import { SnackbarStateModule } from '@epicuro-next/state/snackbar';
import { UserEntitiesModule } from '@epicuro-next/state/user-entities';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { NAMESPACE_NEWS_FEED } from './configuration';
import { CreateEffects } from './state/effects/create.effects';
import { DeleteEffects } from './state/effects/delete.effects';
import { EditEffects } from './state/effects/edit.effects';
import { FetchEffects } from './state/effects/fetch.effects';
import { GetEffects } from './state/effects/get.effects';
import { NavigationEffects } from './state/effects/navigation.effects';
import { PinEffects } from './state/effects/pin.effects';
import { PollingEffects } from './state/effects/polling.effects';
import { RenameEffects } from './state/effects/rename.effects';
import { ResetEffects } from './state/effects/reset.effects';
import {
  NEWS_FEED_STATE_KEY,
  initialState,
  reducer,
} from './state/news-feed.reducer';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(NEWS_FEED_STATE_KEY, reducer, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
    EffectsModule.forFeature([
      FetchEffects,
      NavigationEffects,
      DeleteEffects,
      CreateEffects,
      EditEffects,
      GetEffects,
      PinEffects,
      ResetEffects,
      PollingEffects,
      RenameEffects,
    ]),
    SnackbarStateModule,
    SessionStateModule,
    RouterStoreModule,
    ConfigurationModule.forFeature(NAMESPACE_NEWS_FEED),
    StateSitesStateModule,
    DataEngagementApiModule,
    UserEntitiesModule,
  ],
})
export class StateNewsFeedStateModule {}
